import React from 'react';
import NavItem from '../NavItem';
import style from './style.css';

const DesktopNav = ({ links }) => {
    return (
        <div className={style.desktopNav} style={{ flexBasis: 220 }}>
            <ul className="list-unstyled">
                {links.map(link => (
                    <NavItem {...{ ...link, isIconOnly: false }} key={`${link.to}_${link.label}`} />
                ))}
            </ul>
        </div>
    );
};

export default DesktopNav;
